import { $dfsIterator } from '@lexical/utils';
import { $getRoot } from 'lexical';
import { isNil } from 'lodash';
import * as Constants from 'const';
import { $getTextNodeStyleValueForProperty } from '../../../lexicalUtils';
import { $isCustomParagraphNode, CustomParagraphNode } from '../../../nodes/CustomParagraphNode';
import { FontPluginStyle } from '../style';

export function $updateFontSizeForParagraph(paragraph: CustomParagraphNode): void {
  let maxFontSize: number | null = null;

  const allTextNodes = paragraph.getAllTextNodes();
  for (const node of allTextNodes) {
    const fontSize = parseFloat($getTextNodeStyleValueForProperty(node, FontPluginStyle.FONT_SIZE, ''));
    if (isNaN(fontSize) || isNil(fontSize)) {
      maxFontSize = Constants.DefaultCustomStyle.FONT_SIZE;
    }
    maxFontSize = maxFontSize === null ? fontSize : Math.max(maxFontSize, fontSize);
  }

  if (!maxFontSize) {
    return;
  }
  paragraph.updateFontSize(maxFontSize);
}

export function $updateFontSizeForAllParagraphs(): void {
  let appliedDepth = Infinity;
  for (const { depth, node } of $dfsIterator($getRoot())) {
    if (depth > appliedDepth) {
      continue;
    }
    if (depth <= appliedDepth) {
      appliedDepth = Infinity;
    }
    if ($isCustomParagraphNode(node)) {
      $updateFontSizeForParagraph(node);
      appliedDepth = depth;
    }
  }
}
